<template>
    <vue-pdf-app file-name="polizaGenerada" :pdf=urlPdf></vue-pdf-app>
</template>

<script>

import pdfService from "@/services/pdfs.service.js";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import swal from 'sweetalert';
import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;

Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
    name: "Home",
    props: ["userData"],
    components: {
        VuePdfApp
    },
    data: () => ({
        userData: {
            id: null,
        },
        urlPdf: '',
        resPdf: null,

    }),
    async mounted() {
        await this.$recaptchaLoaded()
        const tokenGetAmazonia = await this.$recaptcha('getAmazonia')
        try {
            let query = this.$route.query;
            if (query.years === '2025' || query.years === '2026') {
                let resPdfAwsNew = await pdfService.pdfAwsBucket(query.id, query.type, query.redirect,tokenGetAmazonia, query.years);
                //console.log("response: ", resPdfAwsNew.fileFinal)
                if (resPdfAwsNew.status == "ok") {
                    this.urlPdf = resPdfAwsNew.fileFinal;
                } else {
                    throw new Error("No se encontró el registro en Aws");
                }
            } else {
                let year = '2024';
                let resPdfAws = await pdfService.pdfAws(query.id, query.type, query.redirect,tokenGetAmazonia, year);
                // console.log("response: ", resPdfAws)
                if (resPdfAws.status == "ok") {
                    this.urlPdf = resPdfAws.fileFinal;
                } else {
                    throw new Error("No se encontró el registro en Aws");
                }
            }
        } catch (error) {
            console.error(error);
            swal({ title: "No se encuentra el registro", icon: "error" });
        }
    },
};

</script>